import React from "react";
import { localize } from "redux-i18n";
import { ChartJS, View } from "@components";

type Props = $Exact<{
  charts: [],
}>;

export class SlaInteractionsBarchart extends React.Component<Props> {
  render() {
    return (
      <div className="department-details-report-table center-aligned-text w-100">
        {this.props.charts.length < 1 ? (
          <h3>{this.props.t("NO_DATA_PLEASE_APPLY_FILTERS")}</h3>
        ) : (
          <View className="gs-container">
            <ChartJS
              type="bar"
              data={{
                labels: this.props.charts
                  .filter(rec => rec.month !== "Period Total")
                  .map(i => i.month),
                datasets: [
                  {
                    label: this.props.t("TOTAL_INBOUND_INTERACTIONS"),
                    data: this.props.charts
                      .filter(rec => rec.month !== "Period Total")
                      .map(i => parseFloat(i.totalInboundInteractions)),
                  },
                  {
                    label: this.props.t("TOTAL_AUTO_CALLBACKS"),
                    data: this.props.charts
                      .filter(rec => rec.month !== "Period Total")
                      .map(i => parseFloat(i.totalAutoCallbacks)),
                  },
                  {
                    label: this.props.t("TOTAL_ASAP_CALLBACKS"),
                    data: this.props.charts
                      .filter(rec => rec.month !== "Period Total")
                      .map(i => parseFloat(i.totalAsapCallbacks)),
                  },
                  {
                    label: this.props.t("TOTAL_SCHEDULED_CALLBACKS"),
                    data: this.props.charts
                      .filter(rec => rec.month !== "Period Total")
                      .map(i => parseFloat(i.totalScheduledCallbacks)),
                  },
                ],
              }}
              options={{ height: 300, isStacked: true, wrapXAxisLabels: true }}
            />
          </View>
        )}
      </div>
    );
  }
}

export default localize()(SlaInteractionsBarchart);
